import type { FC, ReactNode } from "react";

import { m } from "@recobra/i18n/messages";
import { Button } from "@recobra/ui/button";
import { DialogFooter } from "@recobra/ui/dialog";

import type { TaskCompletionBlocker } from "../task-policy";
import { TaskCompletionButton } from "./TaskCompletionButton";

export const TaskBlockedFooter: FC<{
  leadingAction?: ReactNode;
  blocker: TaskCompletionBlocker;
  onClose: () => void;
}> = ({ leadingAction, blocker, onClose }) => {
  const reasons: Record<TaskCompletionBlocker, string> = {
    assignee: m.task_execute_requires_assignee(),
    permission: m.task_complete_not_allowed(),
  };

  return (
    <DialogFooter className="sm:justify-start">
      {leadingAction}
      <Button type="button" variant="outline" onClick={onClose}>
        {m.dialog_close()}
      </Button>
      <TaskCompletionButton disabled disabledReason={reasons[blocker]} />
    </DialogFooter>
  );
};
